import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AgilityRiskService } from '../../providers/agility-risk.service';
import { AssessmentDistributionInfo } from '../../models/assessment-distribution-info';
import { AssessmentDistributionSurvey } from '../../models/assessment-distribution-survey';
import { ActivatedRoute, Router } from '@angular/router';
import { AgilityRiskNavigationService } from '../../providers/agility-risk-navigation.service';
import { AgilityRiskMessageService } from '../../providers/agility-risk-message.service';

@Component({
  selector: 'lib-risk-assessment',
  templateUrl: './risk-assessment.component.html',
  styleUrls: ['./risk-assessment.component.scss']
})
export class RiskAssessmentComponent implements OnInit {
  welcomeUserMsg = '';
  assessmentDistributionInfo: AssessmentDistributionInfo;
  assessmentDistribution: AssessmentDistributionSurvey;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private agilityRiskService: AgilityRiskService,
              private translateService: TranslateService,
              private navigationService: AgilityRiskNavigationService,
              private messageService: AgilityRiskMessageService) {
  }

  ngOnInit(): void {
    const errorMsg = this.translateService.instant('assessment.getAssessmentDistributionFail');

    this.agilityRiskService.getAssessmentDistribution().subscribe({
      next: (resp: AssessmentDistributionInfo) => {
        this.assessmentDistributionInfo = resp;
        this.agilityRiskService.getAssessmentDistributionByMember(this.assessmentDistributionInfo.riskAssessmentDistributionMemberId.id)
          .subscribe({
            next: (assessmentDistributionSurvey) => {
              this.assessmentDistribution = assessmentDistributionSurvey;
              this.welcomeUserMsg = this.translateService.instant('assessment.welcomeUserMsg', {name: this.assessmentDistribution.contact.displayName});
            },
            error: (err) => {
              this.messageService.error(this.translateService.instant('common.error'), errorMsg);
            }
          });
      },
      error: (err) => {
        this.messageService.error(this.translateService.instant('common.error'), errorMsg);
      }
    });
  }

  roundToMinute(seconds: number): number {
    return seconds ? Math.ceil(seconds / 60) : 0;
  }

  startSurvey() {
    this.router.navigate(['survey', this.assessmentDistributionInfo.riskAssessmentDistributionId.id], {relativeTo: this.route});
  }
}
